/* eslint-disable formatjs/no-literal-string-in-jsx */
import React, { type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { SliteLogo } from '@slite/components'

import { Button } from '../../components/Button/Button'
import { Section } from '../../components/Section'
import { WebsiteText } from '../../components/WebsiteText'
import { useRoutes } from '../../routes'
import { getIconFromCompetitor } from './constants'

export const SectionHero = ({
  title,
  subtitle,
  competitorName,
  background = 'moon-dust',
}: {
  title: string | ReactNode
  subtitle: string
  competitorName: string
  background?: string
}) => {
  const routes = useRoutes()
  const CompetitorIcon = getIconFromCompetitor(competitorName)

  return (
    <Section background={background}>
      <div className="grid-12">
        <div className="grid-span-10 grid-offset-1 padding-horizontal-24 text-align-center flexbox flexbox-column flexbox-centered grid-span-12-small grid-offset-0-small">
          <div className="margin-bottom-24 flexbox flexbox-align-center flexbox-column-gap-24 flexbox-column-gap-12-small">
            <SliteLogo
              variant="symbol"
              width={72}
              className="display-none-small"
            />
            <SliteLogo
              variant="symbol"
              width={40}
              className="display-none-not-small"
            />
            <div className="font-family-title font-size-3 font-weight-medium shade-00">
              vs.
            </div>
            <CompetitorIcon size={72} className="display-none-small shade-00" />
            <CompetitorIcon
              size={40}
              className="display-none-not-small shade-00"
            />
          </div>
          <WebsiteText variant="heroTitle" className="margin-bottom-20">
            {title}
          </WebsiteText>
          <WebsiteText variant="body-lg" className="margin-bottom-24">
            {subtitle}
          </WebsiteText>
          <Button variant="primary-brand" href={routes.bookDemo()} size="huge">
            <FormattedMessage
              defaultMessage="Book a demo"
              id="compare.page.cta.bookDemo"
            />
          </Button>
        </div>
      </div>
    </Section>
  )
}
